import * as fragments from './fragments';

export const cartGet = `
query cart($id: ID!) {
  cart(id: $id) {
    ${fragments.cart}
  }
}
`;

export const cartCreate = `
mutation cartCreate($input: CartInput!) {
  cartCreate(input: $input) {
    cart {
      id
    }
    userErrors {
      field
      message
    }
  }
}`;

export const cartAttributesUpdate = `
mutation cartAttributesUpdate($cartId: ID!, $attributes: [AttributeInput!]!) {
  cartAttributesUpdate(attributes: $attributes, cartId: $cartId) {
    cart {
      ${fragments.cart}
    }
    userErrors {
      field
      message
    }
  }
}`;

export const cartLinesAdd = `
mutation cartLinesAdd($cartId: ID!, $lines: [CartLineInput!]!) {
  cartLinesAdd(cartId: $cartId, lines: $lines) {
    cart {
      ${fragments.cart}
    }
    userErrors {
      field
      message
    }
  }
}`;

export const cartLinesRemove = `
mutation cartLinesRemove($cartId: ID!, $lineIds: [ID!]!) {
  cartLinesRemove(cartId: $cartId, lineIds: $lineIds) {
    cart {
      ${fragments.cart}
    }
    userErrors {
      field
      message
    }
  }
}`;

export const cartLinesUpdate = `
mutation cartLinesUpdate($cartId: ID!, $lines: [CartLineUpdateInput!]!) {
  cartLinesUpdate(cartId: $cartId, lines: $lines) {
    cart {
      ${fragments.cart}
    }
    userErrors {
      field
      message
    }
  }
}`;

export const collectionById = `
  query($id: ID!, $first: Int) {
    node(id: $id) {
      ...on Collection {
        title
        descriptionHtml
        headerMetafields: metafields(identifiers: [
          {namespace: "header", key: "desktop_featured_image"},
          {namespace: "header", key: "mobile_featured_image"},
          {namespace: "header", key: "desktop_featured_video"},
          {namespace: "header", key: "mobile_featured_video"}

        ]) {
          key
          value
          namespace
          reference {
            ... on MediaImage {
              image {
                originalSrc
                alt: altText
              }
            }
          }
        }
        products(first: $first) {
          edges {
            node {
              ${fragments.collectionProduct}
            }
          }
        }
      }
    }
  }
`;

export const collectionByIdWithProductCursor = `
  query($id: ID!, $cursor: String) {
    node(id: $id) {
      ...on Collection {
        title
        descriptionHtml
        headerMetafields: metafields(identifiers: [
          {namespace: "header", key: "desktop_featured_image"},
          {namespace: "header", key: "mobile_featured_image"},
          {namespace: "header", key: "desktop_featured_video"},
          {namespace: "header", key: "mobile_featured_video"}

        ]) {
          key
          value
          namespace
          reference {
            ... on MediaImage {
              image {
                originalSrc
                alt: altText
              }
            }
          }
        }
        products(first: 28, after: $cursor) {
          edges {
            node {
              ${fragments.collectionProduct}
            }
          }
          pageInfo {
            hasNextPage
            endCursor
          }
        }
      }
    }
  }
`;

export const productsByTag = (tag, first) => `
  query {
    products(query: "tag:'${tag}'", first: ${first}) {
      nodes {
        ...on Product {
          ${fragments.product}
        }
      }
    }
  }
`;

export const productsByType = (type, first) => `
  query {
    products(query: "product_type:'${type}'", first: ${first}) {
      nodes {
        ...on Product {
          ${fragments.product}
        }
      }
    }
  }
`;
export const productByHandle = () => `
  query product($handle: String!) {
    productByHandle(handle: $handle) {
      ${fragments.product}
    }
  }
`;

export const variantsByOptions = () => `
  query variantsByOptions($handle: String!, $option1: String!, $option2: String!) {
    product(handle: $handle) {
      variantBySelectedOptions(selectedOptions: [{ name:"Blade Replacement", value: $option1}, { name:"Handle Replacement", value: $option2}]) {
        id
        title
      }
    }
  }
`;

export const artworkMetaobjects = `
  query {
    metaobjects(type: "artwork" first: 100) {
      edges {
        node {
          fields {
            type
            key
            value
            reference {
              ... on MediaImage {
                image {
                  originalSrc
                }
              }
            }
          }
        }
      }
    }
  }
`;
